module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer"
  }, [(_vm.item.attr === 'customerName') ? [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'contactName') ? [(_vm.form.customerName.id) ? _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "contactApi",
      "multiselect": false,
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'products') ? [_c('div', {
    staticClass: "products type2"
  }, [_c('input', {
    staticClass: "v-input",
    attrs: {
      "type": "text",
      "placeholder": "暂无关联产品",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("productLen")(_vm.Products.productList)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-area"
  }, [(_vm.Products.productList.length) ? [_vm._v("产品合计(元)：" + _vm._s(_vm.totalPrice) + "；"), _vm._l((_vm.Products.surchargeList), function(item) {
    return _c('span', {
      class: {
        'discount': item.surchargeType === 2
      }
    }, [_vm._v(_vm._s(item.surchargeName) + "(元)：" + _vm._s(_vm._f("fiexd")(item.amount)) + " ; ")])
  })] : [_vm._v("产品合计(元)：0元")]], 2), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": _vm.emitParent
    }
  }, [_vm._v("选择")])])] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'decisionMaker') ? [(_vm.form.customerName.id) ? _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "contactApi",
      "multiselect": true,
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew
    }
  }) : _c('span', [_vm._v("无")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb1c73dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/opportunity/index.vue
// module id = 1332
// module chunks = 82